import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Col, Image, Modal, Row } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { ErrorMessage } from '@hookform/error-message';
import './OptOut.css';
import { companyUniqueId, TelInput, isCompanyActive } from '../../components';
import { ICompany } from '@models';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { isLoading } from '../../components/Loader';
import OptOutFormService from '../../services/OptOutFormService';
import { OptoutForm } from '@models/FormTypes';
import { IOptout } from '@models/ICompany';
import { toast } from 'react-toastify';

function OptOut() {
  const cert_url = useRef(null);
  const [companyInfo, setCompanyInfo] = useState<IOptout>();
  const { uniqueId } = useParams();

  const [optoutRefId, setOptoutRefId] = useRecoilState(companyUniqueId);
  const [companyActive, setCompanyActive] = useRecoilState(isCompanyActive);
  const [errorMessage, setErrorMessage] = useState("");
  const setIsLoading = useSetRecoilState(isLoading);
  const showLoading = useRecoilValue(isLoading);
  const [serverCallInprogress, setServerCallInprogress] = useState(false);
  const [isAlreadyOptedOut, setIsAlreadyOptedOut] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showRevokeSuccessModal, setShowRevokeSuccessModal] = useState(false);
  const [showOptOutConfirmationModal, setShowOptOutConfirmationModal] = useState(false);
  const [isOptingOut, setIsOptingOut] = useState(false);


  const [hasPageExpired, setPageExpired] = useState(false);
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        console.log("User came back via browser back button (bfcache restore)!");
        // 👉 Handle your logic here
        setPageExpired(true);
      } else {
        console.log("Fresh page load, not from cache");
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);


  useEffect(() => {
    console.log("optout ref id : " + uniqueId);
    if (uniqueId && uniqueId !== "") {
      let newOptoutRefNo = uniqueId;
      setOptoutRefId(newOptoutRefNo);
    }
  }, [uniqueId]);
  const {
    register,
    control, trigger, reset,
    setError,
    setFocus,
    clearErrors,
    setValue, getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<OptoutForm>()

  const onSubmit = async (formData: OptoutForm) => {
    if (serverCallInprogress) {
      return false;
    }

    let data = {
      ref_id: companyInfo?.ref_id,
      message: formData.message,
    }

    console.log("Form Data : ", data);
    setServerCallInprogress(true);
    setErrorMessage("");

    OptOutFormService.submitForm(optoutRefId, data)
      .then((response: any) => {
        reset();
        setErrorMessage(response.data.message);
        setShowSuccessModal(true);   // 👈 show modal
        setServerCallInprogress(false);
      })
      .catch((e: any) => {
        if (e.response) {
          console.log(e.response); // => the response payload 
          setErrorMessage(e.response.data.message);

          if (e.response.status === 401) {
            setCompanyActive(false);
          }
        }
        setServerCallInprogress(false);
      });
  }

  const getConsentRequestLink = () => {
    console.log("Link Identifier : ", uniqueId);
    setIsLoading(true);
    OptOutFormService.getInfo(uniqueId?.toString() ?? "")
      .then((response: any) => {
        setCompanyInfo(response.data.info);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      })
      .catch((e: any) => {
        if (e.response.data.company_info) {
          setCompanyInfo(e.response.data.company_info);
        }
        setPageExpired(true);
        setIsLoading(false);
      });
  };
  const handleOptoutClick = async () => {
    let data = {
      ref_id: companyInfo?.ref_id,
    }

    setErrorMessage("");

    OptOutFormService.optoutLink(optoutRefId, data)
      .then((response: any) => {
        setShowOptOutConfirmationModal(false);
        setErrorMessage(response.data.message);
        setShowRevokeSuccessModal(true);   // 👈 show modal

      })
      .catch((e: any) => {
        if (e.response) {
          console.log(e.response);
          toast.error(e.response.data.message);
        }
        setPageExpired(true);
      });
  };
  const handleOptOut = async () => {
    try {
      setIsOptingOut(true);
      await handleOptoutClick();   // call your existing function
    } finally {
      setIsOptingOut(false);
    }
  };

  useEffect(() => {
    if (optoutRefId && optoutRefId !== "") {
      getConsentRequestLink();
    }
  }, [optoutRefId])
  const handleError = (e: any) => {

  }
  const handleCloseErrorModal = () => {
    setShowSuccessModal(false);
    sessionStorage.setItem("cameBack", "true");
    // window.location.href = "https://callerconsent.com/";
  }
  const handleCloseRevokeSuccessModal = () => {
    setShowRevokeSuccessModal(false);
    sessionStorage.setItem("cameBack", "true");
    // window.location.href = "https://callerconsent.com/";
  }

  const handleCloseOptOutConfirmationModal = () => {
    if (!isOptingOut) {
      setShowOptOutConfirmationModal(false);
    }
  }

  return (
    !showLoading ? (

      isAlreadyOptedOut ? <div className="optout-mobile">
        <div className="optout-card success-card">
          <div className="optout-header">

            {companyInfo?.client_logo && (
              <div className="text-center mb-3">
                <Image src={companyInfo.client_logo} alt="Client Logo" fluid />
              </div>
            )}
          </div>
          <div className="optout-body">
            <div className="success-icon">✓</div>

            <h5>You’re all set</h5>

            <p className="small-text">
              You have already opted out of communications from
              <strong> {companyInfo?.company_name}</strong>.
            </p>

            <p className="small-text">
              No further action is needed.
            </p>
          </div>

        </div>
      </div>
        :
        <div className="container optout-mobile">
          <div className="optout-card">
            <div className="optout-header">

              {/* Logo */}
              {companyInfo?.client_logo && (
                <div className="text-center mb-3">
                  <Image src={companyInfo.client_logo} alt="Client Logo" fluid />
                </div>
              )}
            </div>
            <div className="optout-body">
              {/* Header Text */}
              <p className="text-center small-text">
                Company Engagement Page for;
              </p>

              <p className="text-center fw-bold">
                {companyInfo?.caller_name}
                <br />
                <span className="text-center small-text">{companyInfo?.caller_number}</span>
              </p>

              {/* Call Now */}
              <a
                href={`tel:${companyInfo?.company_number}`}
                className="call-now-link"
              >
                Click to Call Now
              </a>

              <p className="phone-number">
                {companyInfo?.company_number}
              </p>

              {/* Message Form */}
              <form onSubmit={handleSubmit(onSubmit, handleError)}>
                <p className="send-message-link">Send a Message</p>

                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Message Area"
                  className="message-area"
                  {...register("message", {
                    required: "Message is required"
                  })}
                />

                <ErrorMessage
                  name="message"
                  errors={errors}
                  render={({ message }) => (
                    <p className="error-message text-center">{message}</p>
                  )}
                />

                <button
                  type="submit"
                  disabled={serverCallInprogress}
                  className="send-btn"
                >
                  Send
                </button>
              </form>

              {/* Consent Links */}
              <div className="consent-footer">
                <a href="/manage-consent">
                  <h5>Manage Consent Preferences</h5>
                </a>

                <p className="small-text mt-1">
                  To Opt-Out of communication from {companyInfo?.company_name},{" "}<br />
                  <a onClick={() => setShowOptOutConfirmationModal(true)} className='click-here-link'>click here</a>
                </p>
              </div>
            </div>
          </div>

          <Modal
            show={showSuccessModal}
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => setShowSuccessModal(false)}
          >
            <Modal.Body className="text-center success-modal-body">
              <div className="success-icon">✓</div>

              <h5 className="mt-3">Thank you</h5>

              <p className="small-text mt-2">
                Your message has been sent successfully.
              </p>

              <button
                className="send-btn mt-3"
                onClick={() => handleCloseErrorModal()}
              >
                Close
              </button>
            </Modal.Body>
          </Modal>

          <Modal
            show={showRevokeSuccessModal}
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => setShowRevokeSuccessModal(false)}
          >
            <Modal.Body className="text-center success-modal-body">
              <div className="success-icon">✓</div>

              <h5 className="mt-3">Thank you</h5>

              <p className="small-text mt-2">
                Your message has been sent successfully.
              </p>

              {/* <p className="small-text">
                If you chose to opt out, your preference has been recorded.
              </p> */}

              <button
                className="send-btn mt-3"
                onClick={() => handleCloseRevokeSuccessModal()}
              >
                Close
              </button>
            </Modal.Body>
          </Modal>

          <Modal
            show={showOptOutConfirmationModal}
            centered
            backdrop="static"
            keyboard={false}
            onHide={() => setShowOptOutConfirmationModal(false)}
          >
            <Modal.Body className="text-center success-modal-body">
              <div className="success-icon">✓</div>

              <h5 className="mt-3">Confirm Your Opt-Out Request</h5>

              <p className="small-text mt-2">
                Please confirm or cancel your Opt-Out request below;
              </p>

              <button
                className="optout-btn mt-3"
                onClick={handleOptOut} disabled={isOptingOut}
              >
                {isOptingOut ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Processing...
                  </>
                ) : (
                  "Confirm Opt-Out"
                )}
              </button>
              <button disabled={isOptingOut}
                className="close-btn mt-3"
                onClick={() => handleCloseOptOutConfirmationModal()}
              >
                Close and Cancel Request
              </button>
            </Modal.Body>
          </Modal>
        </div >
    ) : null
  );

}

export default OptOut
